import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Col, Row } from "reactstrap";
import { connect } from "react-redux";
import {
  capitalizeFirstLetter,
  getColorsAllRGB,
  numberWithCommas,
} from "../../../../helpers/utils";
import ReactApexChart from "react-apexcharts";

const LineChartManager = props => {
  const [options, setOptions] = React.useState({
    chart: {
      toolbar: {
        show: true,
        tools: {
          download: false,
          selection: false,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: false,
          reset: true,
        },
      },
    },
    noData: {
      text: "NO DATA",
      align: "center",
      verticalAlign: "middle",
    },
    dataLabels: {
      enabled: false,
    },
    colors: getColorsAllRGB,
    xaxis: {
      type: "datetime",
      labels: {
        format: "yyyy-MM-dd",
      },
    },
    yaxis: {
      title: {
        text: "PROFIT",
      },
    },
    grid: {
      borderColor: "#f1f1f1",
    },
    stroke: {
      width: 3,
      curve: "smooth",
    },
    fill: {
      type: ["", "gradient"],
      gradient: {
        inverseColors: false,
        shade: "light",
        type: "vertical",
        opacityFrom: 0.55,
        opacityTo: 0.3,
      },
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: value => `${numberWithCommas(parseFloat(value))}`,
        title: {
          formatter: tooltipName => capitalizeFirstLetter(tooltipName) + ":",
        },
      },
    },
  });

  const [series, setSeries] = React.useState([]);

  React.useEffect(() => {
    if (props.data.length > 0) {
      let items = [];
      let sorted = [];
      let total = {};
      props.data.map(i => {
        let find = items.findIndex(f => f.id == i.offer_id);
        if (find < 0) {
          items.push({
            id: i.offer_id,
            name: i?.offer_name || 'None',
            type: "area",
            data: [
              {
                x: new Date(i.date),
                y: parseFloat(i[`${props.type}`]).toFixed(2),
              },
            ],
          });
        } else {
          items[find].data.push({
            x: new Date(i.date),
            y: parseFloat(i[`${props.type}`]).toFixed(2),
          });
        }
      });

      if (items.length > 0) {
        items.map(i => {
          let sort = i.data.sort((a, b) => a.x - b.x);
          sorted.push({
            ...i,
            data: sort,
          });
        });
      }

      if (props.plan) {
        (total.name = "Plan"), (total.type = "line"), (total.data = []);
        props.plan.map(i => {
          total.data.push({
            x: new Date(i.date),
            y: parseFloat(i.total_plan).toFixed(2),
          });
        });
        sorted.unshift(total);
      }
      setOptions({
        ...options,
        yaxis: {
          title: {
            text: props.type.toUpperCase(),
          },
        },
      });
      setSeries(sorted);
    } else {
      setOptions({
        ...options,
        yaxis: {
          title: {
            text: "NONE",
          },
        },
      });
      setSeries([]);
    }
  }, [props.data, props.plan]);

  return (
    <React.Fragment>
      <Row>
        <Col sm={12}>
          <Row className="justify-content-between align-middle">
            <Col xs={12}>
              <ReactApexChartStyled
                options={options}
                series={series}
                type="line"
                height="350"
                className="apex-charts"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  );
};

const ReactApexChartStyled = styled(ReactApexChart)``;

LineChartManager.propTypes = {
  data: PropTypes.array,
  plan: PropTypes.array,
  type: PropTypes.any,
  type_name: PropTypes.string
};

export default connect()(LineChartManager);
